import { Paths } from './routes';
import { AccessRoot, Requirement, permits, legacyFilerAdminOnly } from '../shared/access/access';
export const routeAccess: Record<string, Requirement> = {
  [Paths.home]: 'ADMIN_PROFILE_SELF_READ',
  [Paths.profiles]: 'ADMIN_PROFILE_LIST',
  [Paths.profiles + '/:profileId']: 'ADMIN_PROFILE_READ',
  [Paths.signupRequests]: 'ADMIN_SIGNUP_REQUEST_LIST',
  [Paths.signupRequests + '/:requestId']: 'ADMIN_SIGNUP_REQUEST_READ',
  [Paths.companies]: 'ADMIN_COMPANY_LIST',
  [Paths.companiesStats]: 'ADMIN_COMPANY_STATS_READ',
  [Paths.companies + '/:companyId']: 'ADMIN_COMPANY_READ',
  [Paths.tags]: 'ADMIN_TAG_LIST', [Paths.tags + '/:tagId']: 'ADMIN_TAG_READ',
  [Paths.mediaLibraryTags]: legacyFilerAdminOnly,
  [Paths.mediaLibraryTags + '/:tagId']: legacyFilerAdminOnly,
  [Paths.deliveries]: 'ADMIN_DELIVERY_LIST',
  [Paths.deliveries + '/:deliveryId']: 'ADMIN_DELIVERY_READ',
  [Paths.usages]: 'ADMIN_USAGE_LIST', [Paths.usages + '/:usageId']: 'ADMIN_USAGE_READ',
  [Paths.templates]: 'ADMIN_DELIVERY_TEMPLATE_LIST',
  [Paths.pricingPlans]: 'ADMIN_TARIFF_PLAN_LIST',
  [Paths.emailNotifications]: 'ADMIN_EMAIL_NOTIFICATION_LIST',
  [Paths.integrationDefinitions]: 'ADMIN_ROLE_LIST',
  [Paths.deletionRequests]: 'ADMIN_DELETION_REQUEST_LIST',
  [Paths.settings]: ['ADMIN_TEXT_LABEL_LIST', legacyFilerAdminOnly],
  [Paths.controlSettings]: 'ADMIN_TEXT_LABEL_LIST',
  [Paths.contentSettings]: legacyFilerAdminOnly,
  [Paths.platformRoles]: ['ADMIN_PLATFORM_ROLE_CATALOG_READ', 'ADMIN_PLATFORM_ROLE_ASSIGNMENTS_READ', 'ADMIN_PLATFORM_ROLE_HISTORY_READ'],
  [Paths.authorizationDecisions]: ['ADMIN_AUTHORIZATION_DECISION_READ', 'ADMIN_AUTHORIZATION_DECISION_PARTITIONS_READ'],
  [Paths.billingAccounts]: 'ADMIN_BILLING_ACCOUNT_READ',
  [Paths.billingAccounts + '/:companyId']: 'ADMIN_BILLING_ACCOUNT_READ',
};
export const requirementForPath = (path: string): Requirement =>
  routeAccess[path.split('?')[0]] || Object.entries(routeAccess).find(([pattern]) =>
    new RegExp('^' + pattern.replace(/:[^/]+/g, '[^/]+') + '/?$').test(path.split('?')[0]))?.[1] || '';
export const landingPage = (state: AccessRoot) =>
  [Paths.profiles, Paths.templates, Paths.pricingPlans, Paths.authorizationDecisions, Paths.platformRoles]
    .find(path => permits(state, routeAccess[path])) || Paths.home;
